import { AgTechIndex, Index } from "@agtech/core/utilities/AgTechUtilities";
import { AgTechQuery, AgTechQueryResponses } from "@agtech/core/data/queries/AgTechDataQueries";
import { SaleTaskTemplate, SaleTaskTemplateIndex, SaleTaskTemplateItem, SaleTaskTemplateItemIndex } from "./TaskTemplateData";

export const TaskTemplateDataGetTemplatesQuery: AgTechQuery<any, SaleTaskTemplateIndex> = {
    queryKey: () => ['SaleTaskTemplates'],
    query: (props) => {
        return props.http.getEntity<SaleTaskTemplate[], AgTechIndex<SaleTaskTemplate>>({
            request: 'SaleTaskTemplates',
            convert: templates => Index(templates, template => template.id)
        });
    },
    content: {
        loadingText: 'Loading task templates...',
        failureText: 'Failed to load task templates.'
    }
}

export const TaskTemplateDataGetItemsQuery: AgTechQuery<{ templateId: number }, SaleTaskTemplateItemIndex> = {
    queryKey: ({ templateId }) => ['SaleTaskTemplateItems', templateId],
    query: (props) => {
        // A template being created doesn't have a real id yet - there's nothing to fetch, so skip
        // the network call rather than hitting a nonsensical .../0/Items route.
        if (!props.inputData.templateId) {
            return Promise.resolve(AgTechQueryResponses.Success({}));
        }

        return props.http.getEntity<SaleTaskTemplateItem[], AgTechIndex<SaleTaskTemplateItem>>({
            request: 'SaleTaskTemplates/' + props.inputData.templateId + '/Items',
            convert: items => Index(items, item => item.id)
        });
    },
    content: {
        loadingText: 'Loading template items...',
        failureText: 'Failed to load template items.'
    }
}
